import { useContext, useEffect, useRef, useState } from 'react'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import { PlusCircle } from 'react-bootstrap-icons'
import { useClickOutside } from '../../../../../components/Hooks/useClickOutside'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import { ToDoListAdminContext } from '../ToDoListAdmin'


export default function AddItemComponent({ focused, description, align, className, onAdd, open }) {
    const { GlobalRef } = useContext(CommonFunctionsContext)
    const { focus, setFocus } = useContext(ToDoListAdminContext)
    const [error, setError] = useState()
    const [edit, setEdit] = useState(open ? open : false)
    const ListRef = useRef()
    const ContainerRef = useRef()

    useClickOutside(ContainerRef, () => _handleClear())

    useEffect(() => {
        if (open) {
            // setEdit(open)
            _handleStartAdd()
        }
        if (open && focus && focused && focus.group === focused.group) setTimeout(() => { ListRef.current.focus() }, 500)
        // console.log('open', focus)
    }, [open])

    const _handleKeyEvent = (e) => {
        switch (e.key) {
            case 'Escape': _handleClear(); break;
            case 'Enter': _handleAdd(); break;
            default: break;
        }
    }
    const _handleStartAdd = (e) => {
        setFocus(focused)
        document.addEventListener('keyup', _handleKeyEvent)
        setEdit(true)
        setTimeout(() => { ListRef.current.focus() }, 200)
    }

    const _handleClear = () => {
        document.removeEventListener('keyup', _handleKeyEvent)
        if (ListRef.current) ListRef.current.value = ""
        if (ListRef.current) ListRef.current.placeholder = `New ${description} name`
        setEdit(false)
        setError(undefined)
    }

    const _handleAdd = async () => {
        if (!ListRef.current) return
        if (ListRef.current.value.trim() === "") {
            ListRef.current.placeholder = `Please enter a name for the new ${description}`
            ListRef.current.select()
            setError(true)
            return false
        }
        await onAdd(ListRef.current.value)
        _handleClear()
    }

    return (<div onClick={() => _handleStartAdd()} ref={ContainerRef} className={`add-list-line-item ${className && className}`}>
        {/* <button
            onClick={_handleStartAdd}
            className={`add-list-container ${align} btn btn-sm ${edit && 'd-none'}`}> <PlusCircleDotted className='me-2' />{`Create new ${description}`}</button> */}
        <div
            ref={r => GlobalRef(r, 'FacilityToDoListNewListItemNew')}
            className={'add-list-container-details'}>
            <input onChange={() => setError()} ref={ListRef} className={`form-control form-control-sm add-list-input ${error && 'bg-danger-container'}`} placeholder='New list name' />
            <button onClick={_handleAdd} className='btn btn-sm'><PlusCircle /></button>
        </div>
    </div>)
}